import { ICommonSettings } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigGoogleMapMcpSettings } from "./app-settings-config-google-mcp-map";

export interface IConfigGoogleMcpMapInputState {
  showModal: boolean;
  editingGoogleMcpMapId: string;
}

export interface IConfigGoogleMcpMapInputProps {
  parentConfigValue?: string | null;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleUpdateCustomFormInput?: (formItemName: string[], value: string | null) => void;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigGoogleMcpMapInput extends PureComponent<
  IConfigGoogleMcpMapInputProps,
  IConfigGoogleMcpMapInputState
> {
  formInputName: string[] = ["apiConfig", "googleMapMcpSettingsId"];

  constructor(props: IConfigGoogleMcpMapInputProps) {
    super(props);
    this.state = {
      showModal: false,
      editingGoogleMcpMapId: ""
    };
  }

  openModal = (): void => {
    this.setState({ showModal: true, editingGoogleMcpMapId: "" });
  };

  closeModal = (): void => {
    this.setState({ showModal: false });
  };

  setEditingSetting = (id: string): void => {
    this.setState({ editingGoogleMcpMapId: id, showModal: true });
  };

  handleRestore = (): void => {
    this.props.handleUpdateCustomFormInput?.(this.formInputName, this.props.parentConfigValue ?? null);
  };

  render(): ReactNode {
    return (
      <>
        <ConfigGoogleMapMcpSettings
          formInputName={this.formInputName}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          editingGoogleMcpMapId={this.state.editingGoogleMcpMapId}
          commonSettings={this.props.commonSettings}
          getSectionDescription={this.props.getSectionDescription}
          handleCreateCommonConfig={this.props.handleCreateCommonConfig}
          handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
          handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          label="Google Maps"
          formInputName={this.formInputName}
          options={this.props.commonSettings.googleMapMcpSettings ?? []}
          allowClear
          tooltipContentKey="appsettings_mcp_googlemcpmap"
          onAddNew={this.openModal}
          onEdit={this.setEditingSetting}
          parentConfigValue={this.props.parentConfigValue}
          onRestore={this.handleRestore}
          dropdownTestId="appSettingsMcpGoogleMapDropdown"
          addNewTestId="appSettingsMcpGoogleMapAddNewButton"
          editTestId="appSettingsMcpGoogleMapEditButton"
        />
      </>
    );
  }
}
